export default "__VITE_ASSET__51baf620__"